import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 16v-8h3.334c.92 0 1.666 .895 1.666 2s-.746 2 -1.666 2h-3.334","key":"svg-0"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-1"}]]

const IconParkingCircle = createReactComponent('outline', 'parking-circle', 'ParkingCircle', __iconNode);

export default IconParkingCircle;